import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserMe = {
  userMe: { data: null, loading: false, error: null },
};

export const userMe = createAsyncThunk('user/userMe', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/user/me`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserMe = {
  [userMe.pending]: (state) => {
    state.userMe.loading = true;
  },
  [userMe.fulfilled]: (state, action) => {
    state.userMe.loading = false;
    state.userMe.data = action.payload;
    state.userMe.error = null;
  },
  [userMe.rejected]: (state, action) => {
    state.userMe.loading = false;
    state.userMe.error = action.payload;
  },
};
